<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div class="w-100" [innerHTML]='"copy.html.FIBHotels.FIBHotels"|copy|async'></div>
    </div>
</div>